import { WsCallsLog } from '@gem/call/WsApi/wsCallsApi/WsCallsLog';
import { WsRequestManager } from '@gem/modules/wsClient/wsManagers';

import { WsCallsApiController } from './WsCallsApiController';
import { WsCallsApiNetworkService } from './WsCallsApiNetworkService';

export let wsCallsApiNetworkService: WsCallsApiNetworkService | null = null;
export let wsCallsRequestManager: WsRequestManager | null = null;

let isApiInitialized = false;
export let wsCallsLog: WsCallsLog | null = null;

export let wsCallsApiController: WsCallsApiController | null;

export function initCallsApi(callsUrl: string): void {
  if (isApiInitialized) {
    return;
  }
  wsCallsApiNetworkService = new WsCallsApiNetworkService();
  wsCallsRequestManager = new WsRequestManager(wsCallsApiNetworkService);
  wsCallsLog = new WsCallsLog(wsCallsApiNetworkService);
  wsCallsApiController = new WsCallsApiController(wsCallsApiNetworkService, callsUrl);
  isApiInitialized = true;
}

export function disposeCallsApi(): void {
  isApiInitialized = false;
  wsCallsApiNetworkService = null;
  wsCallsRequestManager = null;
  wsCallsLog = null;
  wsCallsApiController = null;
}
